import ClipboardJS from 'clipboard';
import { GAEvent, GAEventNames } from './analytics/events';
import { Store } from './store/gameStore';

function isWeChatBrowser() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /MicroMessenger/i.test(userAgent);
}

export function showShareModal() {
    GAEvent(GAEventNames.SHOW_SHARE, {});
    Store.pauseGame();
    const shareContainer = document.getElementById('share-modal');
    copyTextToClipboard();
    if (shareContainer) {
        shareContainer.classList.remove('hidden');
        const closeModal = document.getElementById('share-modal-close');
        if (closeModal) {
            closeModal.onpointerdown = hideShareModal;
        }

        const wechatShare = document.getElementById('wechat-share-button');

        if (wechatShare) {
            if (!isWeChatBrowser()) {
                wechatShare.remove();
            }
            wechatShare.addEventListener('click', function () {
                GAEvent(GAEventNames.SHARE_SUCCESSFUL, { sm: 'wechat' });

                wx.ready(function () {
                    wx.updateAppMessageShareData({
                        title: 'Share Title', // The title of the content
                        desc: 'Share Description', // The description
                        link: window.location.href, // The link of the page to share
                        imgUrl: 'https://solitaires.com/path/to/image.jpg',
                    });
                });
            });
        }

        const fav = document.getElementById('share-icon-favorite');
        // if (fav) {
        //     fav.addEventListener('click', function () {
        //         pageTitle = document.title;
        //         pageURL = document.location;
        //         try {
        //             // Internet Explorer solution
        //             eval('window.external.AddFa-vorite(pageURL, pageTitle)'.replace(/-/g, ''));
        //         } catch (e) {
        //             try {
        //                 // Mozilla Firefox solution
        //                 window.sidebar.addPanel(pageTitle, pageURL, '');
        //             } catch (e) {
        //                 // Opera solution
        //                 if (typeof opera == 'object') {
        //                     a.rel = 'sidebar';
        //                     a.title = pageTitle;
        //                     a.url = pageURL;
        //                     return true;
        //                 } else {
        //                     document.getElementById('share-notification-favorite').innerHTML =
        //                         'Press ' +
        //                         (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Command/Cmd' : 'CTRL') +
        //                         ' + D to bookmark this page.';
        //                     showNotification(InfoNotification.ADD_TO_FAVORITE);
        //                 }
        //             }
        //         }
        //         return false;
        //     });
        // }
    }
}

function hideShareModal() {
    Store.resumeGame();
    const shareContainer = document.getElementById('share-modal');
    if (shareContainer) {
        shareContainer.classList.add('hidden');
    }
}

function copyTextToClipboard() {
    const clipboard = new ClipboardJS('.copy-button');

    clipboard.on('success', function (e) {
        showNotification(InfoNotification.COPY_SUCCESS);
    });

    clipboard.on('error', function (e) {
        showNotification(InfoNotification.COPY_FAILURE);
    });
}

enum InfoNotification {
    COPY_SUCCESS,
    COPY_FAILURE,
    ADD_TO_FAVORITE,
}
let notificationTimeout: NodeJS.Timeout;

function showNotification(type: InfoNotification) {
    let id = '';
    switch (type) {
        case InfoNotification.COPY_SUCCESS:
            id = 'share-notification-button-copy';
            GAEvent(GAEventNames.SHARE_SUCCESSFUL, { sm: 'copy' });
            break;
        case InfoNotification.COPY_FAILURE:
            id = 'share-notification-button-copy-failure';
            break;
        case InfoNotification.ADD_TO_FAVORITE:
            id = 'share-notification-favorite';
            break;
    }

    const notification = document.getElementById('share-modal-notification');
    const copyInfo = document.getElementById(id);
    if (copyInfo && notification) {
        copyInfo.classList.remove('hidden');
        notification.classList.remove('hidden');
        if (notificationTimeout) {
            clearTimeout(notificationTimeout);
        }
        notificationTimeout = setTimeout(() => {
            copyInfo.classList.add('hidden');
            notification.classList.add('hidden');
        }, 4000);
    }
}
